import { formatPrice } from '../../../utils/currency';

/**
 * Ordered fill classes for allocation split segments (largest share first) —
 * the single-hue pipeline ramp per the v2 palette rule (never rainbow, never
 * robbie violet in charts).
 */
export const SPLIT_SEGMENT_CLASSES = [
    'bg-pipeline-5',
    'bg-pipeline-4',
    'bg-pipeline-3',
    'bg-pipeline-2',
];

export const formatUnitPrice = (unitPrice?: number, currency?: string): string => {
    if (unitPrice === undefined || unitPrice === null) return 'Price TBD';
    return `${formatPrice(unitPrice, currency || 'INR')}/unit`;
};
